import { Skeleton } from "@red-digital/bricks";
import React from "react";
// @ts-ignore
import styles from "./SkeletonProductCard.module.scss";

interface SkeletonProductCardProps {
  show: boolean;
}

const SkeletonProductCard: React.FC<SkeletonProductCardProps> = ({ show }: SkeletonProductCardProps) => {
  if (!show) return null;

  return (
    <div className={styles.containerQueryWrapper}>
      {/* Small layout - default */}
      <div className={styles.smallLayout}>
        <div className={styles.slotArea}>
          <div className={styles.slotComponent}>
            <Skeleton height="40px" radius="4px" />
          </div>

          <div className={styles.contentArea}>
            <Skeleton height="24px" width="120px" radius="4px" />
            <Skeleton height="36px" width="160px" radius="4px" className={styles.contentTitle} />
          </div>

          <div className={styles.slotComponent}>
            <Skeleton height="40px" radius="4px" />
          </div>
          <div className={styles.slotComponent}>
            <Skeleton height="40px" radius="4px" />
          </div>
          <div className={styles.slotComponent}>
            <Skeleton height="40px" radius="4px" />
          </div>
          <div className={styles.slotComponent}>
            <Skeleton height="40px" radius="4px" />
          </div>
        </div>

        <div className={styles.bottomBanner}>
          <div className={styles.ctaArea}>
            <Skeleton height="40px" width="200px" radius="4px" className={styles.primaryCta} />
          </div>
        </div>
      </div>

      {/* Medium layout - hidden by default, shown by container query */}
      <div className={styles.mediumLayout}>
        <div className={styles.leftSide}>
          <div className={styles.leftSlotComponent}>
            <Skeleton height="40px" radius="4px" />
          </div>
        </div>

        <div className={styles.rightSide}>
          <div className={styles.slotContainer}>
            <div className={styles.slotComponent}>
              <Skeleton height="40px" radius="4px" />
            </div>
            <div className={styles.slotComponent}>
              <Skeleton height="40px" radius="4px" />
            </div>
            <div className={styles.slotComponent}>
              <Skeleton height="40px" radius="4px" />
            </div>
            <div className={styles.slotComponent}>
              <Skeleton height="40px" radius="4px" />
            </div>
          </div>

          <div className={styles.bottomBanner}>
            <div className={styles.ctaArea}>
              <Skeleton height="40px" width="200px" radius="4px" className={styles.primaryCta} />
            </div>
          </div>
        </div>
      </div>

      {/* Large layout - hidden by default, shown by container query */}
      <div className={styles.largeLayout}>
        <div className={styles.leftSide}></div>

        <div className={styles.middleHighlight}>
          <div className={styles.slotContainer}>
            <div className={styles.slotComponent}>
              <Skeleton height="40px" radius="4px" />
            </div>
            <div className={styles.slotComponent}>
              <Skeleton height="40px" radius="4px" />
            </div>
            <div className={styles.slotComponent}>
              <Skeleton height="40px" radius="4px" />
            </div>
            <div className={styles.slotComponent}>
              <Skeleton height="40px" radius="4px" />
            </div>
          </div>
        </div>

        <div className={styles.rightSide}>
          <div className={styles.ctaArea}>
            <Skeleton height="40px" width="100px" radius="4px" className={styles.primaryCta} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonProductCard;
